import { render, staticRenderFns } from "./add_value.vue?vue&type=template&id=359ed0b6&scoped=true&"
import script from "./add_value.vue?vue&type=script&lang=js&"
export * from "./add_value.vue?vue&type=script&lang=js&"
import style0 from "./add_value.vue?vue&type=style&index=0&id=359ed0b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ed0b6",
  null
  
)

export default component.exports